console.log('From tabs component!!!');